import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MedicationAddComponent } from './medication-add.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  declarations: [MedicationAddComponent],
  imports: [
    CommonModule,
    IonicModule, FormsModule, ReactiveFormsModule,
    TranslateModule
  ],
  exports: [MedicationAddComponent],
})
export class MedicationAddModule { }
